<template>
  <div class="pb-6">
    <h1 class="mt-3 fw-6 text-center">暗标文件检测工具</h1>
    <div class="mt-3 box" @click="toAdvertisement">
    <img src="../../../assets/zmning/advertisement.jpg" alt=""  class="scaled-image"/>
  </div>
  </div>
 
</template>

<script>
import VipJumpUtil from '@/util/vipJumpUtil';
export default {
  data() {
    return {
      imgSrc: ''
    }
  },
  methods:{
    toAdvertisement() {
      VipJumpUtil.jumpToVip(this)
    }
  }
}
</script>

<style scoped lang="scss">
.scaled-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: pointer;

}
</style>
